if ($(".genesis-ratings-stars-blank").length > 0) {
  var genesisRatingsStar1 = $(".genesis-ratings-star-1");
  var genesisRatingsStar2 = $(".genesis-ratings-star-2");
  var genesisRatingsStar3 = $(".genesis-ratings-star-3");
  var genesisRatingsStar4 = $(".genesis-ratings-star-4");
  var genesisRatingsStar5 = $(".genesis-ratings-star-5");
  var genesisRatingsStarsBlank = $(".genesis-ratings-stars-blank");
  var genesisRatingsStarsBlankAdded = $(".genesis-ratings-stars-blank-added");
  var genesisRatingsStarsBlankV;

  genesisRatingsStarsBlank.on("click", function() {
    genesisRatingsStarsBlankV = $(this).attr("value");

    if (genesisRatingsStarsBlankV == "1") {
      genesisRatingsStar1.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar2.removeClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar3.removeClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar4.removeClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar5.removeClass("genesis-ratings-stars-blank-added");
    } else if (genesisRatingsStarsBlankV == "2") {
      genesisRatingsStar1.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar2.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar3.removeClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar4.removeClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar5.removeClass("genesis-ratings-stars-blank-added");
    } else if (genesisRatingsStarsBlankV == "3") {
      genesisRatingsStar1.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar2.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar3.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar4.removeClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar5.removeClass("genesis-ratings-stars-blank-added");
    } else if (genesisRatingsStarsBlankV == "4") {
      genesisRatingsStar1.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar2.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar3.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar4.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar5.removeClass("genesis-ratings-stars-blank-added");
    } else if (genesisRatingsStarsBlankV == "5") {
      genesisRatingsStar1.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar2.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar3.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar4.addClass("genesis-ratings-stars-blank-added");
      genesisRatingsStar5.addClass("genesis-ratings-stars-blank-added");
    }
  });
}

if ($(".genesis-thankyou-c").length > 0) {
  var genesisThankyouC = $(".genesis-thankyou-c");
  var genesisThankyouCloseBTN = $(".genesis-thankyou-closeBTN");

  if (
    window.location.href.indexOf("/pages/register-your-genesis-fan/?complete") >
    -1
  ) {
    genesisThankyouC.addClass("active");

    genesisThankyouCloseBTN.click(function() {
      genesisThankyouC.removeClass("active");
    });
  }
}

if ($("#genesis-date").length > 0) {
  var GenesisRegDate = $("#genesis-date");
  GenesisRegDate.datepicker();
}
